import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-evisa-link-site',
  templateUrl: './evisa-link-site.component.html',
  styleUrls: ['./evisa-link-site.component.css']
})
export class EvisaLinkSiteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
